import React from "react"
import {Container} from "react-bootstrap";
import '../styles/App.css';
import SideNav from "../shared/SideNav";
import SwaggerLayout from "./Swagger";
import {BrowserRouter, Navigate, Route, Routes, useLocation} from "react-router-dom";
import GetYourToken from "./GetYourToken";
import Documentation from "./Documentation";


const App = () => {
    return (
        <Container className="page-container">
            <BrowserRouter>
                <SideNav/>
                <Routes>
                    <Route path="/auth" element={<GetYourToken/>}/>
                    <Route path="/documentation" element={<Documentation/>}/>
                    <Route path="/documentation/invoice-submission" element={<SwaggerLayout/>}/>
                    <Route path="" element={<Navigate to="/auth"/>}/>
                </Routes>
            </BrowserRouter>
        </Container>
    );
}

export default App;
